import { useBrowserLanguageState } from '@/hooks/store';

import formatPrice from '../utils/formatPrice';

export default function useFormatPrice() {
	const browserLanguage = useBrowserLanguageState();
	return (price: number, currency: string) => formatPrice(price, currency, browserLanguage ?? undefined);
}
